var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"title"},[_vm._v("实时数据")]),_c('div',{class:[_vm.isScroll ? 'scroll-content' : 'no-scroll-content']},[_c('div',{staticClass:"scroll-list",attrs:{"id":"slist"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }